import { lijuItemsPath, savedLijuField } from "../user/save-liju-markup.js";

const controlSelector = ".cb-save-liju";

function hasSession(document: Document): boolean {
  return document.documentElement.dataset["cbSession"] === "in";
}

function draw(button: HTMLButtonElement, held: boolean): void {
  button.toggleAttribute("data-cb-saved", held);
  const label = button.querySelector<HTMLElement>(".cb-save-liju-label");

  if (label !== null) {
    label.textContent = held ? "Saved" : "Save";
  }
}

async function held(
  fetched: typeof fetch,
  uuids: readonly string[],
): Promise<readonly string[]> {
  const query = new URLSearchParams({ ids: uuids.join(",") });
  const response = await fetched(`${lijuItemsPath}?${query.toString()}`);
  const body = (await response.json()) as { saved?: readonly string[] | null };

  return body.saved ?? [];
}

async function toggle(
  fetched: typeof fetch,
  uuid: string,
): Promise<readonly string[] | null> {
  const body = new URLSearchParams({ [savedLijuField]: uuid });
  const response = await fetched(lijuItemsPath, { method: "POST", body });
  const answer = (await response.json()) as {
    saved?: readonly string[] | null;
  };

  return answer.saved ?? null;
}

export function startSaveLiju(
  document: Document,
  fetched: typeof fetch = globalThis.fetch,
): void {
  const controls = [...document.querySelectorAll<HTMLElement>(controlSelector)];
  const buttons = controls.flatMap((control) => {
    const button = control.querySelector<HTMLButtonElement>(
      ".cb-save-liju-action",
    );
    return button === null ? [] : [button];
  });

  if (hasSession(document) && buttons.length > 0) {
    void held(
      fetched,
      buttons.map((button) => button.value),
    )
      .then((saved) => {
        for (const button of buttons) {
          draw(button, saved.includes(button.value));
        }
      })
      .catch(() => undefined);
  }

  for (const control of controls) {
    const form = control.querySelector<HTMLFormElement>(".cb-save-liju-form");
    const button = control.querySelector<HTMLButtonElement>(
      ".cb-save-liju-action",
    );

    if (form === null || button === null) {
      continue;
    }

    form.addEventListener("submit", (event) => {
      event.preventDefault();

      if (!hasSession(document)) {
        const offer = control.querySelector<HTMLElement>(".cb-save-liju-offer");
        if (offer !== null) {
          offer.hidden = false;
        }
        return;
      }

      void toggle(fetched, button.value)
        .then((saved) => {
          if (saved === null) {
            const offer = control.querySelector<HTMLElement>(
              ".cb-save-liju-offer",
            );
            if (offer !== null) {
              offer.hidden = false;
            }
          } else {
            draw(button, saved.includes(button.value));
          }
        })
        .catch(() => form.submit());
    });
  }
}
